import { Box, Stack, TextField, Typography } from '@mui/material';
import useProjectInfoProvider from 'hooks/useProjectInfoProvider';
import { isEmpty } from 'lodash';
import { memo, useMemo } from 'react';
import { useAppDispatch } from 'store';
import { showMessage } from 'store/message/messageSlice';

function GridPoint({
  id,
  color,
  value,
  label,
  width,
  height,
  typography,
  disabled,
}: {
  id: string;
  color: string;
  value: string;
  label: string;
  width: number;
  height: number;
  typography: string;
  disabled?: boolean;
}): JSX.Element {
  const dispatch = useAppDispatch();
  const { onChangeDC, dcInputs } = useProjectInfoProvider();
  const { stepper1, stepper2 } = dcInputs;
  const { ...others } = stepper2;

  const handleCalcSum = useMemo(() => {
    return (
      Object.values(others)
        .map(obj => Number(obj))
        .reduce((acc, curr) => acc + curr, 0) || 0
    );
  }, [others]);
  const ipsativeRowCount = stepper1.ipsativeExcel?.rowCount || 0;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const tmpValue = event.target.value;
    if (/^\d*$/.test(tmpValue)) {
      const newValue = Number(tmpValue);
      const oldValue = Number(value);
      const totalChange = newValue - oldValue;
      const newRemainCount = ipsativeRowCount - (handleCalcSum + totalChange);
      if (newRemainCount < 0) {
        dispatch(
          showMessage({
            message: '입력값을 다시 확인해 주세요(남은 문항 수가 0보다 적어질 수 없습니다.)',
            variant: 'warning',
          }),
        );
        return;
      }
      onChangeDC(`stepper2.${id}`, `${newValue}`);
    }
  };
  const handleBlur = () => {
    if (isEmpty(value) || !/^\d+$/.test(value)) {
      onChangeDC(`stepper2.${id}`, '0');
    }
  };
  return (
    <Box
      sx={{
        width,
        minWidth: width,
        height,
        background: color,
        border: '4px solid #DAD9D9',
        borderRadius: '15px',
      }}
    >
      <Stack direction="column" spacing={3} justifyContent="space-evenly" sx={{ height: '100%', display: 'flex' }}>
        <Typography sx={{ typography, display: 'flex', justifyContent: 'center' }}>{label}</Typography>
        <Box sx={{ backgroundColor: 'mind.custom.white', borderRadius: '7px', m: '8px!important' }}>
          <TextField
            id={id}
            variant="outlined"
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              '& .MuiOutlinedInput-root': {
                typography,
                color: value === '0' ? 'mind.grid.boxZero' : 'mind.black.A0',
              },
              '& .MuiOutlinedInput-input': {
                p: 1,
                textAlign: 'center',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                border: 'none !important',
              },
              '& .MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled': {
                textFillColor: '#000000',
              },
            }}
            disabled={disabled}
          />
        </Box>
      </Stack>
    </Box>
  );
}

export default memo(GridPoint);
